import React from "react";
import {useOverrides} from "@quarkly/components";
import {Text, Box, Section} from "@quarkly/widgets";

const defaultProps = {
    "padding": "80px 0",
    "sm-padding": "60px 0",
    "color": "#ffffff",
    "background": "transparent",
    "id": "faq"
};
const overrides = {
    "box": {
        "kind": "Box",
        "props": {
            "margin": "0",
            "display": "flex",
            "flex-wrap": "wrap"
        }
    },
    "box1": {
        "kind": "Box",
        "props": {
            "padding": "16px",
            "width": "30%",
            "lg-width": "100%",
            "lg-margin": "0 0 40px 0"
        }
    },
    "box2": {
        "kind": "Box",
        "props": {
            "display": "flex",
            "flex-direction": "column"
        }
    },
    "text": {
        "kind": "Text",
        "props": {
            "as": "h2",
            "font": "--headline1",
            "margin": "0 0 16px 0",
            "color": "#ffffff",
            "font-family": "Plus Jakarta Sans, sans-serif",
            "children": "FAQs"
        }
    },
    "text1": {
        "kind": "Text",
        "props": {
            "as": "p",
            "font": "--lead",
            "margin": "0",
            "color": "rgba(255, 255, 255, 0.65)",
            "children": "Need answers? We have them!"
        }
    },
    "box3": {
        "kind": "Box",
        "props": {
            "padding": "0px",
            "width": "70%",
            "lg-width": "100%"
        }
    },
    "box4": {
        "kind": "Box",
        "props": {
            "display": "flex",
            "flex-direction": "row",
            "flex-wrap": "wrap",
            "justify-content": "space-between"
        }
    },
    "box5": {
        "kind": "Box",
        "props": {
            "display": "flex",
            "flex-direction": "column",
            "width": "47%",
            "padding": "30px 24px",
            "lg-width": "100%",
            "margin": "0 0 24px 0"
        }
    },
    "box6": {
        "kind": "Box",
        "props": {
            "display": "flex",
            "flex-direction": "column"
        }
    },
    "text2": {
        "kind": "Text",
        "props": {
            "as": "h3",
            "font": "--headline3",
            "margin": "0 0 12px 0",
            "color": "#ffffff",
            "children": "Do I need programming skills?"
        }
    },
    "text3": {
        "kind": "Text",
        "props": {
            "as": "p",
            "font": "--base",
            "margin": "0",
            "color": "rgba(255, 255, 255, 0.7)",
            "children": "Programming is not required. Everything works via a visual interface. Write to us on Telegram for a 15-minute demonstration."
        }
    },
    "box7": {
        "kind": "Box",
        "props": {
            "display": "flex",
            "flex-direction": "column",
            "width": "47%",
            "padding": "30px 24px",
            "lg-width": "100%",
            "margin": "0 0 24px 0"
        }
    },
    "box8": {
        "kind": "Box",
        "props": {
            "display": "flex",
            "flex-direction": "column"
        }
    },
    "text4": {
        "kind": "Text",
        "props": {
            "as": "h3",
            "font": "--headline3",
            "margin": "0 0 12px 0",
            "color": "#ffffff",
            "children": "What types of trading strategies are supported?"
        }
    },
    "text5": {
        "kind": "Text",
        "props": {
            "as": "p",
            "font": "--base",
            "margin": "0",
            "color": "rgba(255, 255, 255, 0.7)",
            "children": "Signal strategies, grid strategies, and custom algorithms. Contact support to find out how they work in your trading style."
        }
    },
    "box9": {
        "kind": "Box",
        "props": {
            "display": "flex",
            "flex-direction": "column",
            "width": "47%",
            "padding": "30px 24px",
            "lg-width": "100%",
            "margin": "0 0 24px 0"
        }
    },
    "box10": {
        "kind": "Box",
        "props": {
            "display": "flex",
            "flex-direction": "column"
        }
    },
    "text6": {
        "kind": "Text",
        "props": {
            "as": "h3",
            "font": "--headline3",
            "margin": "0 0 12px 0",
            "color": "#ffffff",
            "children": "Can I integrate custom indicators?"
        }
    },
    "text7": {
        "kind": "Text",
        "props": {
            "as": "p",
            "font": "--base",
            "margin": "0",
            "color": "rgba(255, 255, 255, 0.7)",
            "children": "Yes. Standard and custom TradingView indicators work without any problems. Need help with integration? Write to our Telegram support."
        }
    },
    "box11": {
        "kind": "Box",
        "props": {
            "display": "flex",
            "flex-direction": "column",
            "width": "47%",
            "padding": "30px 24px",
            "lg-width": "100%",
            "margin": "0 0 24px 0"
        }
    },
    "box12": {
        "kind": "Box",
        "props": {
            "display": "flex",
            "flex-direction": "column"
        }
    },
    "text8": {
        "kind": "Text",
        "props": {
            "as": "h3",
            "font": "--headline3",
            "margin": "0 0 12px 0",
            "color": "#ffffff",
            "children": "How do I set up notifications?"
        }
    },
    "text9": {
        "kind": "Text",
        "props": {
            "as": "p",
            "font": "--base",
            "margin": "0",
            "color": "rgba(255, 255, 255, 0.7)",
            "children": <span>Notifications in Telegram and integration via webhook are available. You will find all detailed step-by-step setup instructions in our <a href="https://docs.cdzv.com/" target="_blank" rel="noopener noreferrer" style={{ color: "#FD6DF9", textDecoration: "underline", fontWeight: "600" }}>official documentation</a>.</span>
        }
    }
};

const CdzvFaq = props => {
    const {
        override,
        children,
        rest
    } = useOverrides(props, overrides, defaultProps);
    return <Section {...rest}>
        <Box {...override("box")}>
            <Box {...override("box1")}>
                <Box {...override("box2")}>
                    <Text {...override("text")} />
                    <Text {...override("text1")} />
                </Box>
            </Box>
            <Box {...override("box3")}>
                <Box {...override("box4")}>
                    <Box {...override("box5")} className="glass-card">
                        <Box {...override("box6")}>
                            <Text {...override("text2")} />
                            <Text {...override("text3")} />
                        </Box>
                    </Box>
                    <Box {...override("box7")} className="glass-card">
                        <Box {...override("box8")}>
                            <Text {...override("text4")} />
                            <Text {...override("text5")} />
                        </Box>
                    </Box>
                    <Box {...override("box9")} className="glass-card">
                        <Box {...override("box10")}>
                            <Text {...override("text6")} />
                            <Text {...override("text7")} />
                        </Box>
                    </Box>
                    <Box {...override("box11")} className="glass-card">
                        <Box {...override("box12")}>
                            <Text {...override("text8")} />
                            <Text {...override("text9")} />
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
        {children}
    </Section>;
};

Object.assign(CdzvFaq, {
    ...Section,
    defaultProps,
    overrides
});
export default CdzvFaq;